import type { Message } from '../../../api/types';
import { noteBooking, splitAtReference } from './bookingNote';
import { JobLink } from './JobLink';

/**
 * A message's words, with the number of the booking it records made into a
 * link to that booking — the note the service posts beside every booking a
 * thread makes ("Dispatch job #48213 created from this thread").
 *
 * Every other message renders exactly as its words, so a layout can draw every
 * body through this and need not ask which kind it has.
 */
export function BookingNoteText({ message }: { message: Message }) {
  const content = message.content ?? '';
  const booking = noteBooking(message);
  if (!booking) return <>{content}</>;
  const { before, ref, after } = splitAtReference(content);
  if (!ref) return <>{content}</>;
  return (
    <>
      {before}
      <JobLink kind={booking.kind} id={booking.id} className="note-job-ref">
        {ref}
      </JobLink>
      {after}
    </>
  );
}
